export default __webpack_public_path__ + "03c7730c16684ebcc065aea1d33e9fc1.png";